import { e as escape_html, p as pop, a as push } from "../../chunks/index2.js";
import "clsx";
import { p as page } from "../../chunks/index3.js";
function _error($$payload, $$props) {
  push();
  $$payload.out.push(`<main class="flex h-screen flex-col items-center justify-center bg-gray-300">`);
  if (page.status === 404) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<h1 class="text-3xl">Sorry, the page can't be found.</h1>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (page.status === 500) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<h1 class="text-3xl">Oops, there was an error on our side.</h1> <p class="mt-2 text-xs">Server side error</p>`);
    } else {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`<h1 class="text-3xl">${escape_html(page.status)}: ${escape_html(page.error?.message)}</h1>`);
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--> <button class="hover:outline-primary mt-4 rounded-xs p-2 outline outline-[0.3px] transition-colors hover:bg-gray-200">Go back</button></main>`);
  pop();
}
export {
  _error as default
};
